// Services from this project.
import {
  AlertService,
  AuthorizedAccountService,
  CacheService,
  CertificateService,
  CredentialService,
  FileService,
  InvoicesService,
  JsonSchemaService,
  NaviService,
  OnboardingService,
  PartnerService,
  ReportsService,
  RowTypeService,
  SessionService,
  SettingsService,
  SignatureService,
  UiCrudHelpers,
  UiHelpers,
  UiTranslatorService,
  UploadService,
  UsecasesService,
  UserSettingsService,
  VarmaPensionService,
  WizardService,
  WorkflowService,
} from ".";

import { AjaxNg1 } from "../ajax/AjaxNg1";

// @salaxy/core services and interfaces
import {
  Absences,
  AccountingTargets,
  Accounts,
  AccountSettings,
  AuthorizedAccounts,
  BeneficialOwnersApi,
  BusinessTemplates,
  Calculations,
  Calculator,
  CalendarEvents,
  Certificates,
  Client,
  Credentials,
  CustomerInvoices,
  Datasets,
  Employments,
  Files,
  HolidayYears,
  Imports,
  Invoices,
  IrEarningsPayments,
  IrPayerSummaries,
  MessageThreads,
  OAuth2,
  Onboardings,
  Overview,
  PartnerServices,
  PaymentChannelApi,
  Payrolls,
  Payrolls4,
  ProApi,
  Records,
  ReferenceObjects,
  Reports,
  Session,
  Taxcards,
  Test,
  Usecases,
  Workers,
  ServiceModels,
  HouseholdYears,
} from "@salaxy/core";

// @salaxy/report services
import {
  Templates,
} from "@salaxy/reports";

/**
 * Provides methods for registering the Services to module
 * (and other related metadata in the future).
 */
export class ServicesRegistration {

  /** Gets the services for Module registration. */
  public static getServices () {
    return {
      AjaxNg1,
      AlertService,
      AuthorizedAccountService,
      CacheService,
      CertificateService,
      CredentialService,
      CustomerInvoices,
      FileService,
      InvoicesService,
      JsonSchemaService,
      NaviService,
      OnboardingService,
      PartnerService,
      ReportsService,
      RowTypeService,
      SessionService,
      SettingsService,
      SignatureService,
      UiCrudHelpers,
      UiHelpers,
      UiTranslatorService,
      UploadService,
      UsecasesService,
      UserSettingsService,
      VarmaPensionService,
      WizardService,
      WorkflowService,
    };
  }

  /** Gets the services from the @salaxy/core project that need to be registered for NG1 dependency injection. */
  public static getCoreServices () {
    return {
      Absences,
      AccountingTargets,
      Accounts,
      AccountSettings,
      AuthorizedAccounts,
      BeneficialOwnersApi,
      BusinessTemplates,
      Calculations,
      Calculator,
      CalendarEvents,
      Certificates,
      Client,
      Credentials,
      Datasets,
      Employments,
      Files,
      HolidayYears,
      Imports,
      Invoices,
      IrEarningsPayments,
      IrPayerSummaries,
      MessageThreads,
      OAuth2,
      Onboardings,
      Overview,
      PartnerServices,
      PaymentChannelApi,
      Payrolls,
      Payrolls4,
      ProApi,
      Records,
      ReferenceObjects,
      Reports,
      Session,
      Taxcards,
      Templates,
      Test,
      Usecases,
      Workers,
      ServiceModels,
      HouseholdYears,
    };
  }
}
